<script setup lang="ts">
import { Accordion } from './internal/'
import type { HTMLAttributes } from 'vue'

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const props = withDefaults(defineProps<{
    class?: HTMLAttributes['class']
    type?: 'single' | 'multiple'
}>(), {
    class: '',
    type: 'single',
})

const modelValue = defineModel<string | string[]>('modelValue')

</script>

<template>
    <Accordion
        v-model="modelValue"
        :type="props.type"
        collapsible
    >
        <slot></slot>
    </Accordion>
</template>
